import { useState, useEffect } from 'react';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ServiceCard from '@/components/base/ServiceCard';
import { categories, services } from '@/mocks/services';

export default function Categories() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [filteredServices, setFilteredServices] = useState(services);

  useEffect(() => {
    if (activeCategory === 'all') {
      setFilteredServices(services);
    } else {
      setFilteredServices(services.filter((s) => s.category === activeCategory));
    }
  }, [activeCategory]);

  const activeCategoryName = categories.find((c) => c.id === activeCategory)?.name || '全部服务';

  return (
    <>
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', path: '/' },
            { label: '服务分类' },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                服务分类
              </h1>
              <p className="text-foreground-500 text-sm md:text-base">
                六大服务品类，覆盖凌晨生活的每一个角落
              </p>
            </div>

            <div className="flex items-center justify-center gap-2 flex-wrap mb-10">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.id)}
                  className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                    activeCategory === cat.id
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200/60'
                  }`}
                >
                  <i className={`${cat.icon} text-sm`}></i>
                  {cat.name}
                </button>
              ))}
            </div>

            <h2 className="text-lg font-heading font-semibold text-foreground-800 mb-6">
              {activeCategoryName} <span className="text-foreground-400 font-normal text-sm">({filteredServices.length}项服务)</span>
            </h2>

            {filteredServices.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredServices.map((service) => (
                  <ServiceCard
                    key={service.id}
                    name={service.name}
                    description={service.description}
                    price={service.price}
                    imageUrl={service.imageUrl}
                    tags={service.tags}
                    category={service.category}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <i className="ri-inbox-line text-4xl text-foreground-300 mb-3"></i>
                <p className="text-foreground-400">该分类暂无服务</p>
              </div>
            )}
          </div>
        </section>
      </main>
    </>
  );
}